//数学函数--11个
export const MathFunc = [
  {
    "key": "NumberThousandSeparator",
    "name": "數字千位分隔",
    "params": [
      {
        "key": "property",
        "name": "數字類型字段",
        "type": "int32"
      }
    ],
    "description": `【功能】對數字添加千位分割符，以逗號作為千位分隔符
【參數】
  【property】字段（鍊式結構）
【返回值】字符型
【示例】
  【場景】提交單據Order，單據包含總費用totalCost
  【需求】優化總費用展示，對總費用添加千位分隔符
  【舉例】數字千位分隔(Order.totalCost)
  【返回值】1,234,567.89`,
    "type": "Math",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "abs",
    "name": "絕對值",
    "params": [
      {
        "key": "value",
        "name": "數值",
        "type": "double"
      }
    ],
    "description": `【功能】：返回一個數值的絕對值\n【返回值類型】：數值(Double)\n【示例】：絕對值(-1.5)【返回值】：1.5`,
    "type": "Math",
    "keyFront": "Math",
    "className": ""
  },
  {
    "key": "Round",
    "name": "四捨五入"
  },
  {
    "key": "round",
    "name": "四捨五入",
    "params": [
      {
        "key": "value1",
        "name": "數值",
        "type": "double"
      },
      {
        "key": "value2",
        "name": "小數位數",
        "type": "int32"
      }
    ],
    "description": `【功能】：根據小數位數精度，對數值四捨五入\n【value1】：數值\n【value2】：四捨五入小數位數\n【返回值類型】：數值(Double)\n【示例】：四捨五入(1.52,1)【返回值】：1.5`,
    "type": "Math",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "random",
    "name": "隨機數",
    "params": [],
    "description": `【功能】：隨機生成大於等於 0.0 且小於 1.0 的偽隨機值\n【返回值類型】：數值(Double)\n【示例】：隨機數()【返回值】：0.624508349393`,
    "type": "Math",
    "keyFront": "Math",
    "className": ""
  },
  {
    "key": "sin",
    "name": "正弦",
    "params": [
      {
        "key": "value",
        "name": "數值",
        "type": "double"
      }
    ],
    "description": `【功能】：返回一個數字的正弦值\n【返回值類型】：數值(Double)一個以弧度表示的角\n【示例】：正弦(1)【返回值】：0.84187098`,
    "type": "Math",
    "keyFront": "Math",
    "className": ""
  },
  {
    "key": "cos",
    "name": "餘弦",
    "params": [
      {
        "key": "value",
        "name": "數值",
        "type": "double"
      }
    ],
    "description": `【功能】：返回一個數字的餘弦值\n【返回值類型】：數值(Double)一個以弧度表示的角\n【示例】：餘弦(3)【返回值】：-0.9899924`,
    "type": "Math",
    "keyFront": "Math",
    "className": ""
  },
  {
    "key": "ceil",
    "name": "向上舍入",
    "params": [
      {
        "key": "value",
        "name": "數值",
        "type": "double"
      }
    ],
    "description": `【功能】：返回大於或等於函數參數，並且與之最接近的整數\n【返回值類型】：數值(Int32)\n【示例】：向上舍入(3.2)【返回值】：4`,
    "type": "Math",
    "keyFront": "Math",
    "className": ""
  },
  {
    "key": "floor",
    "name": "向下舍入",
    "params": [
      {
        "key": "value",
        "name": "數值",
        "type": "double"
      }
    ],
    "description": `【功能】：返回小於或等於函數參數，並且與之最接近的整數\n【返回值類型】：數值(Int32)\n【示例】：向下舍入(3.2)【返回值】：3`,
    "type": "Math",
    "keyFront": "Math",
    "className": ""
  },
  {
    "key": "BankerRound",
    "name": "銀行家舍入"
  },
  {
    "key": "bankerRound",
    "name": "銀行家舍入",
    "params": [
      {
        "key": "value1",
        "name": "數值",
        "type": "double"
      },
      {
        "key": "value2",
        "name": "小數位數",
        "type": "int32"
      }
    ],
    "description": `【功能】：使用銀行家舍入標準，把指定數字舍入為最接近的數字\n【value1】：舍入數值\n【value2】：舍入小數位數\n【返回值類型】：數值(Double)\n【示例】：銀行家舍入(36.124,2)【返回值】：36.12`,
    "type": "Math",
    "keyFront": "DefaultFunction",
    "className": ""
  }
]